var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletFooterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9972 19.9994C14.6843 19.9994 11.9996 22.6849 11.9996 25.9994V53.9994C11.9996 57.3122 14.6879 59.9994 18.0025 59.9994H61.9996C65.3134 59.9994 67.9996 57.3131 67.9996 53.9994V52.9994C67.9996 51.8948 68.8951 50.9994 69.9996 50.9994C71.1042 50.9994 71.9996 51.8948 71.9996 52.9994V53.9994C71.9996 59.5222 67.5225 63.9994 61.9996 63.9994H18.0025C12.4806 63.9994 7.99963 59.5232 7.99963 53.9994V25.9994C7.99963 20.4773 12.4736 15.9994 17.9972 15.9994H61.9962C67.5179 15.9994 71.9996 20.4754 71.9996 25.9994V28.9994C71.9996 30.104 71.1042 30.9994 69.9996 30.9994C68.8951 30.9994 67.9996 30.104 67.9996 28.9994V25.9994C67.9996 22.6868 65.311 19.9994 61.9962 19.9994H17.9972Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9996 41.9701C36.8951 41.9701 35.9996 41.0747 35.9996 39.9701C35.9996 34.4634 40.4637 29.9994 45.9703 29.9994L58.9996 29.9994C60.1042 29.9994 60.9996 30.8948 60.9996 31.9994C60.9996 33.104 60.1042 33.9994 58.9996 33.9994L45.9703 33.9994C42.6728 33.9994 39.9996 36.6726 39.9996 39.9701C39.9996 41.0747 39.1042 41.9701 37.9996 41.9701Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.9996 36.9994C71.1042 36.9994 71.9996 37.8948 71.9996 38.9994V39.9701C71.9996 45.4929 67.5225 49.9701 61.9996 49.9701H48.9996C47.8951 49.9701 46.9996 49.0747 46.9996 47.9701C46.9996 46.8655 47.8951 45.9701 48.9996 45.9701H61.9996C65.3134 45.9701 67.9996 43.2838 67.9996 39.9701V38.9994C67.9996 37.8948 68.8951 36.9994 69.9996 36.9994Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9996 37.9994C36.8951 37.9994 35.9996 38.8948 35.9996 39.9994C35.9996 45.5061 40.4637 49.9701 45.9703 49.9701H58.9996C60.1042 49.9701 60.9996 49.0747 60.9996 47.9701C60.9996 46.8655 60.1042 45.9701 58.9996 45.9701H45.9703C42.6728 45.9701 39.9996 43.2969 39.9996 39.9994C39.9996 38.8948 39.1042 37.9994 37.9996 37.9994Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.9996 26.9994C71.1042 26.9994 71.9996 27.8948 71.9996 28.9994C71.9996 31.7707 69.7397 33.9994 66.9882 33.9994L56.9996 33.9994C55.8951 33.9994 54.9996 33.104 54.9996 31.9994C54.9996 30.8948 55.8951 29.9994 56.9996 29.9994L66.9882 29.9994C67.5504 29.9994 67.9996 29.5418 67.9996 28.9994C67.9996 27.8948 68.8951 26.9994 69.9996 26.9994Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletFooterIcon);
export default __webpack_public_path__ + "static/media/walletFooterIcon.2a478f66afe61f46b1ef4d06e1b2a7ef.svg";
export { ForwardRef as ReactComponent };